/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Entity_UserInputs */

const cs_enum_entity_user = /** @type {(inputs: Enum_Entity_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatel`)
};

const en_enum_entity_user = /** @type {(inputs: Enum_Entity_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Enum_Entity_UserInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_entity_user = /** @type {((inputs?: Enum_Entity_UserInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Entity_UserInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_entity_user(inputs)
	return cs_enum_entity_user(inputs)
});